import classNames from "classnames";
import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	title: {
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: 2,
		letterSpacing: "2px",
		color: theme.palette.colors.darkSlateBlue,
		margin: 0,
		padding: 0,
		textTransform: "uppercase",
		position: "relative",
		marginLeft: "31px",
		paddingBottom: "8px",
		"&:after": {
			content: "''",
			position: "absolute",
			height: "2px",
			width: "79px",
			bottom: "0",
			left: 0,
			backgroundColor: theme.palette.colors.purplishBlue,
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		title: {
			"&:after": {
				width: "58px",
			},
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		title: {
			fontSize: "16px",
			lineHeight: 2.25,
			letterSpacing: "1.8px",
			marginLeft: "21px",

			"&:after": {
				width: "48px",
			},
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		title: {
			fontSize: "16px",
			lineHeight: 1,
			marginLeft: 0,
			paddingBottom: "0px",

			"&:after": {
				display: "none",
			},
		},
	},
	withoutMargin: {
		margin: 0,
	},
}));

const TariffTableTitle = ({ children, withoutMargin, style }) => {
	const { title, withoutMargin: withoutMarginClass } = useStyles();

	return (
		<div
			className={classNames(title, {
				[withoutMarginClass]: withoutMargin,
			})}
			style={style}
		>
			{children}
		</div>
	);
};

export default TariffTableTitle;
